/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function CopyCellsRequestFromJSON(json) {
    return CopyCellsRequestFromJSONTyped(json, false);
}
export function CopyCellsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        sourceExpression: json['sourceExpression'],
        targetCells: json['targetCells'],
    };
}
export function CopyCellsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        sourceExpression: value.sourceExpression,
        targetCells: value.targetCells,
    };
}
